
import "../../styles/application_header.css";
import { MdOutlineSegment } from "react-icons/md";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setChangePasswordFlg } from "../../usermanagement/actions/userAction";
import labels from "../../usermanagement/labels/users_en.json";
import { logout } from "../../common/actions/commonActions";

function ApplicationHeader({
  collapsed,
  setCollapsed,
  fullName,
  departmentId,
  roleId,
  // labels = {},
  userProps,
}) {
  const dispatch = useDispatch();

  const { allDepartments = [] } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const { roleByDept = [] } = useSelector(
    (state) => state.userManagementReducer,
    shallowEqual
  );

  const selectedDepartment =
    allDepartments.find(
      (singleDepartment) => singleDepartment.id == departmentId
    )?.name || "IT";

  const selectedRole =
    roleByDept.find((singleRole) => singleRole.id == roleId)?.name ||
    "Super Admin";

  return (
    <div className="fixed-header">
      {/* Banner */}
      <div className="row m-0">
        <img
          src="/logos/banner.png"
          width="100%"
          height="111px"
          alt="banner"
        />
      </div>

      {/* Bottom navbar strip */}
      <div className="header-bar">
        {/* LEFT - Sidebar Toggle */}
        {/* <div
          className={`toggle_button ${collapsed ? "bg-color" : ""}`}
          onClick={() => setCollapsed(!collapsed)}
        > */}
        <div
          className={`toggle_button sidebar-icon ${collapsed ? "active-toggle" : ""}`}
          onClick={() => setCollapsed(!collapsed)}
        >
          <MdOutlineSegment />
        </div>

        {/* RIGHT - Super Admin Dropdown */}
        <div className="header-user-dropdown">
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="light"
              id="dropdown-basic"
              className="admin-btn textTransf-cap"
            >
              {fullName || "Super Admin"}
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item className="font-14 text-center">
                <img
                  className="h-20 w-20"
                  src="../../logos/default_user_profile.png"
                  alt="user Profile"
                />
              </Dropdown.Item>

              <Dropdown.Item className="font-14">
                {labels.Department || "Department"} : {selectedDepartment}
              </Dropdown.Item>

              <Dropdown.Item className="font-14">
                {labels.Role || "Role"} : {selectedRole}
              </Dropdown.Item>

              <Dropdown.Item
                className="font-14"
                onClick={() => dispatch(setChangePasswordFlg(true))}
              >
                {labels.ChangePassword || "Change Password"}
              </Dropdown.Item>

              <Dropdown.Item
                className="font-14"
                onClick={() => dispatch(logout(userProps))}
              >
                {labels.Logout || "Logout"}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default ApplicationHeader;